import { StoreLayout } from "../../components/StoreLayout";

const Section = ({ n, title, children }) => (
  <section className="mt-8" data-testid={`terms-section-${n}`}>
    <h2 className="font-[Outfit] text-xl md:text-2xl font-bold text-[#1E293B]">{n}. {title}</h2>
    <div className="mt-2 space-y-3 text-[#475569] leading-relaxed text-[15px]">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <StoreLayout>
      <div className="bg-white border-b border-[#E2E8F0]">
        <div className="max-w-3xl mx-auto px-5 py-12">
          <p className="uppercase text-xs tracking-[0.2em] font-semibold text-[#4F46E5]">Legal</p>
          <h1 className="font-[Outfit] text-4xl md:text-5xl font-extrabold tracking-tight mt-2">Terms &amp; Conditions</h1>
          <p className="text-[#475569] mt-3">Last updated: June 2026</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-5 py-10">
        <p className="text-[#475569] leading-relaxed text-[15px]">
          These Terms &amp; Conditions ("Terms") govern your use of the Fixigo Home Services website and services
          ("Fixigo", "we", "us"). By accessing our website, booking a service, or registering as a partner, you agree
          to be bound by these Terms. Please read them carefully.
        </p>

        <Section n="1" title="About Fixigo">
          <p>Fixigo Home Services is a home-services marketplace operating in Mumbai, Pune and Bengaluru. We connect
          customers with verified independent service professionals ("Partners") for services such as appliance repair,
          installation, cleaning, plumbing, electrical work and pest control.</p>
        </Section>

        <Section n="2" title="Eligibility">
          <p>You must be at least 18 years of age and capable of entering into a legally binding contract under the
          Indian Contract Act, 1872 to use our services. By using Fixigo you confirm that the information you provide
          is accurate and complete.</p>
        </Section>

        <Section n="3" title="Bookings &amp; Service Requests">
          <p>When you place a booking, you submit a request for a service at the price displayed at the time of booking.
          A booking is confirmed once a Partner is assigned. Service availability, slots and timelines are indicative
          and may vary based on Partner availability and location.</p>
        </Section>

        <Section n="4" title="Pricing &amp; Payments">
          <p>All prices are displayed in Indian Rupees (₹) and are inclusive of applicable taxes unless stated otherwise.
          Fixigo currently operates on a <strong>pay-after-service</strong> model — you pay once the service is completed.
          Additional charges for spare parts, materials or extra work will be communicated and agreed upon before such
          work is carried out.</p>
        </Section>

        <Section n="5" title="Cancellations &amp; Rescheduling">
          <p>You may cancel or reschedule a booking before a Partner begins the service, at no charge. Repeated last-minute
          cancellations or no-shows may affect your ability to book in the future. If a Partner is unable to complete a
          job, we will attempt to reassign it at the earliest.</p>
        </Section>

        <Section n="6" title="Fixigo Guarantee &amp; Warranty">
          <p>Eligible services may carry a limited service warranty as indicated at the time of booking. Warranty covers
          the specific work performed and excludes pre-existing faults, misuse, third-party tampering, or issues
          unrelated to the original service. To claim warranty support, contact us within the stated warranty window.</p>
        </Section>

        <Section n="7" title="Customer Responsibilities">
          <p>You agree to provide a safe working environment, accurate address and contact details, and access to the
          premises and equipment required for the service. You are responsible for securing valuables and informing us
          of any hazards at the service location.</p>
        </Section>

        <Section n="8" title="Partners">
          <p>Partners are independent professionals and not employees of Fixigo. While we verify Partners during
          onboarding, you acknowledge that Fixigo acts as a facilitator. Partners are expected to maintain professional
          conduct, punctuality and quality standards.</p>
        </Section>

        <Section n="9" title="Limitation of Liability">
          <p>To the maximum extent permitted by law, Fixigo's total liability for any claim arising out of a service is
          limited to the amount paid by you for that specific service. Fixigo is not liable for indirect, incidental, or
          consequential damages. Nothing in these Terms excludes liability that cannot be excluded under applicable law.</p>
        </Section>

        <Section n="10" title="Intellectual Property">
          <p>All content on this website — including the Fixigo name, logo, text, graphics and design — is owned by or
          licensed to Fixigo and may not be copied or reused without our prior written consent.</p>
        </Section>

        <Section n="11" title="Changes to these Terms">
          <p>We may update these Terms from time to time. The latest version will always be available on this page with
          a revised "Last updated" date. Continued use of our services constitutes acceptance of the updated Terms.</p>
        </Section>

        <Section n="12" title="Governing Law &amp; Jurisdiction">
          <p>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction
          of the courts of Bengaluru, Karnataka.</p>
        </Section>

        <Section n="13" title="Contact Us">
          <p>For any questions about these Terms, reach us at <strong>support@fixigohomeservices.in</strong> or
          <strong> +91 91529 43297</strong> (call or WhatsApp).</p>
        </Section>
      </div>
    </StoreLayout>
  );
}
